/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { DrawerState } from "../../types/DrawerState.ts";

const drawerTranslations = {
  type: {
    activity: "Aktivität",
    note: "Notiz",
    beaFax: "beA/Fax",
    message: "Nachricht",
    inquiryToCustomer: "Anfrage",
    caseDescription: "Fallzusammenfassung",
    documentEditor: "Entwurf",
    email: "E-Mail",
  } satisfies Record<DrawerState["type"], string>,
};

export default drawerTranslations;
